(function(){

  // ─── GUARD: Sai imediatamente se for bot, crawler, editor Shopify ou Lighthouse ───
  const isDesignMode = window.Shopify && window.Shopify.designMode;
  const isBot = /googlebot|bingbot|slurp|duckduckbot|baiduspider|yandexbot|sogou|exabot|facebot|ia_archiver|pagespeed|pingdom|gtmetrix|lighthouse|crawler|spider|robot|headless/i.test(navigator.userAgent)
    || navigator.webdriver
    || window.__nightwatch
    || window.Cypress
    || !!window._lighthouse;
  if(isDesignMode || isBot) return;

  // ─── CONFIGURAÇÃO ───
  const SITE_EU = 'https://countlessmoments.eu';
  const SITE_US = 'https://countlessmoments.com';
  const COOKIE_PREF    = 'cm_loc_pref_v8';
  const COOKIE_COUNTRY = 'cm_loc_country_v8';
  const COOKIE_REDIRECT = 'cm_redirected_v8';
  const LOCAL_CODES = ['PT','ES','FR'];
  const EU_CODES    = ['AT','BE','BG','CY','CZ','DE','DK','EE','FI','GR','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SE','SI','SK','ES','FR'];
  const US_CODES    = ['US','MX'];
  const FETCH_TIMEOUT = 5000;
  const REDIRECT_COOLDOWN_MS = 60 * 1000; // 1 minuto em ms

  // ─── STRINGS DE UI POR PAÍS ───
  const STRINGS = {
    PT: { title:'Loja portuguesa disponível',   msg:'Envios mais rápidos e portes mais baratos.',                        go:'Loja PT',        stay:'Ficar aqui'   },
    ES: { title:'Tienda española disponible',   msg:'Envíos más rápidos y gastos de envío más baratos.',                 go:'Tienda ES',      stay:'Quedar aquí'  },
    FR: { title:'Boutique française disponible',msg:'Livraisons plus rapides et frais de port moins chers.',             go:'Boutique FR',    stay:'Rester ici'   },
    US: { title:'Shopping from the US?',        msg:'Faster shipping & local pricing available.',                        go:'Visit US Store', stay:'Stay here'    },
    EU: { title:'Visiting from Europe?',        msg:'We have a European store for faster shipping & prices in euros.',   go:'Go to EU Store', stay:'Stay here'    }
  };

  // ─── ESTADO INTERNO ───
  let dom = {};
  let popupHandled = false;
  let cookieCache  = null;
  let htmlInjected = false;
  let escHandler   = null;

  // ─── COOKIES ───

  function parseCookies(){
    if(cookieCache) return cookieCache;
    cookieCache = {};
    document.cookie.split('; ').forEach(c => {
      const idx = c.indexOf('=');
      if(idx === -1) return;
      const k = c.substring(0, idx).trim();
      const v = c.substring(idx + 1);
      if(k) cookieCache[k] = decodeURIComponent(v);
    });
    return cookieCache;
  }

  function getCookie(name){
    return parseCookies()[name] || null;
  }

  function setCookie(name, val, days=365){
    const d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    // FIX #20: flag Secure em HTTPS, alinhado com o language switcher
    const secure = window.location.protocol === 'https:' ? ';Secure' : '';
    document.cookie = `${name}=${encodeURIComponent(val)};path=/;expires=${d.toUTCString()};SameSite=Lax${secure}`;
    cookieCache = null;
  }

  function hasRecentRedirect(){
    const redirectTime = getCookie(COOKIE_REDIRECT);
    if(!redirectTime) return false;
    const elapsed = Date.now() - parseInt(redirectTime, 10);
    return elapsed < REDIRECT_COOLDOWN_MS;
  }

  function markRedirect(){
    const expires = new Date(Date.now() + REDIRECT_COOLDOWN_MS);
    // FIX #20: flag Secure em HTTPS, alinhado com o language switcher
    const secure = window.location.protocol === 'https:' ? ';Secure' : '';
    document.cookie = `${COOKIE_REDIRECT}=${encodeURIComponent(Date.now())};path=/;expires=${expires.toUTCString()};SameSite=Lax${secure}`;
    cookieCache = null;
  }

  // ─── BANNER SHOPIFY ───

  function toggleBanner(hide){
    const banners = document.querySelectorAll('#shopify-pc__banner, #shopify-pc__banner--mobile');
    banners.forEach(b => b.style.display = hide ? 'none' : '');
  }

  // ─── INJEÇÃO DE HTML ───

  function injectHTML(){
    if(htmlInjected) return;
    if(!document.body) return;
    document.body.insertAdjacentHTML('afterbegin',`
      <div id="cm-location-overlay">
        <div id="cm-location-modal" role="dialog" aria-modal="true" aria-labelledby="cm-title" aria-describedby="cm-text">
          <h3 id="cm-title"></h3>
          <p id="cm-text"></p>
          <div class="cm-buttons">
            <a id="cm-visit-other" href="#" target="_top"></a>
            <button id="cm-stay"></button>
          </div>
        </div>
      </div>`);
    htmlInjected = true;

    dom.overlay  = document.getElementById('cm-location-overlay');
    dom.title    = document.getElementById('cm-title');
    dom.text     = document.getElementById('cm-text');
    dom.visitBtn = document.getElementById('cm-visit-other');
    dom.stayBtn  = document.getElementById('cm-stay');
  }

  // ─── POPUP ───

  function showPopup(cc, targetSite, type='normal'){
    popupHandled = false;

    injectHTML();
    if(!dom.overlay || !dom.title || !dom.visitBtn || !dom.stayBtn) return;

    const strKey = type === 'EU' ? 'EU' : (US_CODES.includes(cc) ? 'US' : cc);
    const str = STRINGS[strKey];
    if(!str) return; // país sem string definida

    dom.title.textContent    = str.title;
    dom.text.textContent     = str.msg;
    dom.visitBtn.textContent = str.go;
    dom.stayBtn.textContent  = str.stay;
    dom.visitBtn.href        = targetSite;

    toggleBanner(true);
    dom.overlay.style.display       = 'flex';
    dom.overlay.style.pointerEvents = 'all';
    dom.visitBtn.style.pointerEvents = 'all';
    dom.stayBtn.style.pointerEvents  = 'all';

    dom.visitBtn.onclick = () => {
      if(popupHandled) return;
      popupHandled = true;
      removeEscListener();
      setCookie(COOKIE_PREF, type === 'EU' ? 'EU' : cc);
      markRedirect();
      // Navegação feita nativamente pelo <a href> — compatível com in-app browsers
    };

    const stayAction = () => {
      if(popupHandled) return;
      popupHandled = true;
      removeEscListener();
      setCookie(COOKIE_PREF, 'Stay', 365);
      dom.overlay.style.display = 'none';
      toggleBanner(false);
    };

    dom.stayBtn.onclick = () => requestAnimationFrame(stayAction);
    dom.overlay.onclick = e => { if(e.target === dom.overlay) requestAnimationFrame(stayAction); };

    // FIX #11 (a11y): fechar com a tecla Escape, equivalente a "Ficar aqui"
    escHandler = e => { if(e.key === 'Escape') requestAnimationFrame(stayAction); };
    document.addEventListener('keydown', escHandler);
  }

  function removeEscListener(){
    if(escHandler){
      document.removeEventListener('keydown', escHandler);
      escHandler = null;
    }
  }

  // ─── UTILITÁRIOS ───

  function normalizePath(p){
    return ('/' + p.trim().replace(/^\/+|\/+$/g,'')).replace(/\/{2,}/g,'/');
  }

  function stripLangPrefix(pathname){
    // Remove /pt/, /es/, /fr/ mas GARANTE sempre o slash inicial
    const stripped = pathname.replace(/^\/(pt|es|fr)\//, '/');
    return stripped.startsWith('/') ? stripped : '/' + stripped;
  }

  function normalizeCC(cc){
    return (cc || '').trim().toUpperCase();
  }

  // FIX #1: remoção segura de um parâmetro da query string, sem deixar
  // query strings inválidas a começar por '&' ou '?&'.
  function removeQueryParam(search, key){
    const params = new URLSearchParams(search);
    params.delete(key);
    const str = params.toString();
    return str ? '?' + str : '';
  }

  // FIX #2: teste de prefixo de pasta de idioma robusto, evitando falsos
  // positivos do tipo '/ptarmigan' quando se procura '/pt'.
  function isInLangFolder(path, cc){
    const prefix = '/' + cc.toLowerCase();
    return path === prefix || path.startsWith(prefix + '/');
  }

  // FIX #12: anexa um parâmetro a uma query string já construída, com o
  // separador correto ('?' ou '&'), para passar cm_pref entre domínios.
  function appendParam(search, key, value){
    return search + (search ? '&' : '?') + key + '=' + encodeURIComponent(value);
  }

  // FIX #13: AbortController cancela mesmo o pedido em vez de o deixar a
  // correr em background, e limpa o timer quando o fetch resolve a tempo.
  function fetchWithTimeout(url, timeout=FETCH_TIMEOUT){
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeout);
    return fetch(url, { signal: ctrl.signal }).finally(() => clearTimeout(timer));
  }

  // ─── LÓGICA PRINCIPAL ───

  // FIX #9 (Speed Index): detectCountry corre em duas fases.
  //  - Fase 1 (cedo, no parse do script): trata os redirects por cookie/URL,
  //    que terminam em location.replace e abortam o carregamento na mesma.
  //    Quando chega ao ramo que mostraria o overlay (precisa de deteção nova),
  //    NÃO o executa — agenda a Fase 2 e sai.
  //  - Fase 2 (deferred=true, após load + idle): corre o fetch / país em cache
  //    que pinta o overlay, já fora da janela que o Speed Index mede.
  // No Lighthouse (sessão sem cookies) só existe o caminho da Fase 2, por isso
  // o overlay nunca cai dentro da medição.

  function detectCountry(deferred){
    if(hasRecentRedirect()){
      return;
    }

    const hostname  = window.location.hostname;
    const rawPath   = window.location.pathname || '/';
    const path      = normalizePath(rawPath.toLowerCase());
    const hash      = window.location.hash; // FIX #10: preservar âncoras em redirects
    // FIX #19: comparação exata de domínio em vez de indexOf('.com')/('.eu').
    // Evita que um preview em *.myshopify.com seja tratado como loja US.
    // Em qualquer domínio que não seja um dos nossos, ambos ficam false e o
    // script fica inerte (não redireciona nem mostra popup).
    const isOnCOM   = hostname === 'countlessmoments.com' || hostname.endsWith('.countlessmoments.com');
    const isOnEU    = hostname === 'countlessmoments.eu'  || hostname.endsWith('.countlessmoments.eu');

    // ── Parâmetro ?cm_pref= na URL — gravado pelo domínio de origem para evitar loops ──
    const urlParams  = new URLSearchParams(window.location.search);
    const cmPref = normalizeCC(urlParams.get('cm_pref'));
    if(cmPref && (LOCAL_CODES.includes(cmPref) || US_CODES.includes(cmPref) || cmPref === 'EU')){
      setCookie(COOKIE_PREF, cmPref); // grava preferência no domínio atual
      // FIX #1: limpa o parâmetro da URL sem reload, de forma segura
      // FIX #10: mantém o hash ao limpar a URL
      const cleanUrl = window.location.pathname + removeQueryParam(window.location.search, 'cm_pref') + hash;
      window.history.replaceState(null, '', cleanUrl);
      return; // já está no sítio certo (foi redirecionado pelo domínio de origem)
    }

    // ── Parâmetro ?lang= na URL (prioridade máxima) ──
    const langParam  = normalizeCC(urlParams.get('lang'));
    if(langParam && (LOCAL_CODES.includes(langParam) || US_CODES.includes(langParam) || langParam === 'EN')){
      if(langParam === 'EN'){
        setCookie(COOKIE_PREF, 'Stay');
        const cleanUrl = window.location.pathname + removeQueryParam(window.location.search, 'lang') + hash;
        window.history.replaceState(null, '', cleanUrl);
        return;
      }
      setCookie(COOKIE_PREF, langParam);
      const isOnCorrectSite = (
        (langParam === 'US'              && isOnCOM) ||
        (LOCAL_CODES.includes(langParam) && isOnEU)
      );
      if(isOnCorrectSite){
        // FIX #14: limpa o ?lang= da URL também quando já está no sítio certo,
        // para não ficar lixo na barra de endereço, em partilhas e analytics
        const cleanUrl = window.location.pathname + removeQueryParam(window.location.search, 'lang') + hash;
        window.history.replaceState(null, '', cleanUrl);
        return;
      }

      markRedirect();
      // FIX #1: usa removeQueryParam para preservar restantes parâmetros sem lixo
      // FIX #15: passa cm_pref= ao domínio de destino para que este grave o
      // cookie de imediato e não corra a deteção (que podia mostrar um popup
      // contraditório a quem acabou de escolher loja explicitamente)
      const keptSearch = removeQueryParam(window.location.search, 'lang');
      if(langParam === 'US'){
        window.location.replace(SITE_US + stripLangPrefix(window.location.pathname) + appendParam(keptSearch, 'cm_pref', 'US') + hash);
      } else {
        window.location.replace(SITE_EU + '/' + langParam.toLowerCase() + stripLangPrefix(window.location.pathname) + appendParam(keptSearch, 'cm_pref', langParam) + hash);
      }
      return;
    }

    // ── Cookie de preferência guardado ──
    const cached = getCookie(COOKIE_PREF);
    if(cached){
      if(cached === 'Stay' || cached === 'EU') return; // EU genérico não faz redirect automático

      if(cached === 'US' && !isOnCOM){
        markRedirect();
        // Passa cm_pref=US para que o .com grave o cookie imediatamente e não volte a redirecionar
        window.location.replace(SITE_US + stripLangPrefix(window.location.pathname) + appendParam(window.location.search, 'cm_pref', 'US') + hash);
        return;
      }
      if(LOCAL_CODES.includes(cached) && isOnCOM){
        markRedirect();
        // Passa cm_pref=XX para que o .eu grave o cookie imediatamente e não volte a redirecionar
        window.location.replace(SITE_EU + '/' + cached.toLowerCase() + stripLangPrefix(window.location.pathname) + appendParam(window.location.search, 'cm_pref', cached) + hash);
        return;
      }
      // FIX #2: usa isInLangFolder em vez de path.startsWith para evitar falsos positivos
      if(LOCAL_CODES.includes(cached) && isOnEU && !isInLangFolder(path, cached)){
        markRedirect();
        window.location.replace(SITE_EU + '/' + cached.toLowerCase() + stripLangPrefix(window.location.pathname) + window.location.search + hash);
        return;
      }
      // Já está no sítio certo
      return;
    }

    // ── A partir daqui não há preferência guardada: é preciso deteção nova,
    //    que pode terminar a mostrar o overlay. Na Fase 1 (cedo) NÃO corremos
    //    isto — agendamos a Fase 2 e saímos, para o overlay não cair na janela
    //    de medição do Speed Index. ──
    if(!deferred){
      schedulePopupPhase();
      return;
    }

    // ── FIX #7: usa COOKIE_COUNTRY em cache antes de chamar a API de novo ──
    const cachedCountry = getCookie(COOKIE_COUNTRY);
    if(cachedCountry){
      decideFromCountry(normalizeCC(cachedCountry), { isOnEU, isOnCOM, path });
      return;
    }

    // ── Deteção via API Shopify (só quando não há país em cache) ──
    const endpoint = (window.Shopify?.routes?.root || '/') + 'browsing_context_suggestions.json';
    fetchWithTimeout(endpoint)
      .then(r => {
        if(!r.ok) throw new Error('Network response was not ok');
        return r.json();
      })
      .then(d => {
        const raw = d?.detected_values?.country?.handle;
        if(!raw) return;
        const cc = normalizeCC(raw);
        setCookie(COOKIE_COUNTRY, cc, 7);
        decideFromCountry(cc, { isOnEU, isOnCOM, path });
      })
      .catch(err => console.warn('[CM] Country detection failed:', err));
  }

  // FIX #7: lógica de decisão extraída para reutilizar entre cache e API
  function decideFromCountry(cc, ctx){
    const { isOnEU, isOnCOM, path } = ctx;
    const isEU    = EU_CODES.includes(cc);
    const isLocal = LOCAL_CODES.includes(cc);
    const isUS    = US_CODES.includes(cc);
    const hash    = window.location.hash; // FIX #10

    if(isOnEU){
      if(isLocal && !isInLangFolder(path, cc)){
        showPopup(cc, SITE_EU + '/' + cc.toLowerCase());
      } else if(isUS){
        // FIX #16: passa cm_pref=US ao .com para gravar a preferência no
        // destino sem nova deteção (e FIX #10: mantém o hash)
        showPopup(cc, SITE_US + stripLangPrefix(window.location.pathname) + appendParam(window.location.search, 'cm_pref', 'US') + hash);
      }
      // se isLocal && já está na pasta correta → não faz nada
    } else if(isOnCOM){
      if(isLocal){
        showPopup(cc, SITE_EU + '/' + cc.toLowerCase() + '?lang=' + cc);
      } else if(isEU && !isLocal){
        // FIX #17: usa cm_pref=EU em vez de lang=EU — o handler de ?lang= não
        // aceita 'EU', por isso o parâmetro nunca era limpo nem a preferência
        // gravada no .eu. O handler de cm_pref aceita 'EU' e trata de tudo.
        showPopup('EU', SITE_EU + '?cm_pref=EU', 'EU');
      }
      // se isUS && isOnCOM → não faz nada
    }
  }

  // ─── INIT (duas fases) ───

  // FIX #9 (Speed Index): Fase 2. Corre o ramo que pinta o overlay (fetch /
  // país em cache) só depois de a página estar visualmente assente, fora da
  // janela que o Speed Index mede. O popup surge poucos ms mais tarde, o que é
  // impercetível para quem está a navegar.
  function schedulePopupPhase(){
    const run = () => {
      if('requestIdleCallback' in window){
        requestIdleCallback(() => detectCountry(true), { timeout: 2000 });
      } else {
        setTimeout(() => detectCountry(true), 200);
      }
    };

    if(document.readyState === 'complete'){
      run();
    } else {
      window.addEventListener('load', run, { once: true });
    }
  }

  // Fase 1 (cedo): trata redirects por cookie/URL o quanto antes, para que um
  // visitante recorrente salte para o domínio certo sem ver a página errada
  // pintar inteira. Se não houver preferência guardada, esta chamada agenda
  // internamente a Fase 2 (via schedulePopupPhase) e sai.
  // FIX #18 (performance): a Fase 1 só usa document.cookie e window.location,
  // não toca no DOM, por isso corre IMEDIATAMENTE no parse do script em vez de
  // esperar pelo DOMContentLoaded — o redirect de um visitante recorrente
  // dispara centenas de ms mais cedo. A injeção de HTML só acontece na Fase 2,
  // que corre depois do load, quando o body já existe garantidamente.
  detectCountry(false);

})();